import Keycloak from 'keycloak-js'
import { useStorage } from './useStorage'

export const useKeycloak = () => {
  const { setIdTokenParsed, setKeycloakToken, getLogout, deleteLogout } = useStorage()

  const keycloak = new Keycloak({
    realm: `${process.env.VUE_APP_REALM}`,
    clientId: 'mrs_client',
    url: `${process.env.VUE_APP_AUTH}`
  })

  const setToken = (keycloak) => {
    setKeycloakToken(keycloak.token)
    setIdTokenParsed(keycloak.idTokenParsed)
  }

  const init = async () =>
    keycloak.init({ onLoad: 'check-sso' }).then((auth) => {
      const logout = getLogout

      if (!auth) {
        keycloak.login({ idpHint: 'saml' })
        return
      }
      if (logout) {
        deleteLogout()
        keycloak.logout()
        return
      }

      if (keycloak.token) setToken(keycloak)
    })

  return { init }
}
